import { createGenericDispatcher } from '../action-dispatcher-factory';

import Job from '../../api/job-api-client';
import { addNotificationAction } from '../notifications/notifications';

export const updateJob = (jobId: number, jobUpdate: Record<string, any>, isEditing?: boolean) =>
  createGenericDispatcher({
    name: 'UPDATE_JOB',
    loadFunction: () => new Job(jobId).update(jobUpdate),
    args: { jobId, jobUpdate },
    onSuccess: (dispatch) => {
      if (isEditing) {
        dispatch(
          addNotificationAction({
            key: `updating-job-success-${jobId}`,
            message: 'Your job has been saved successfully',
          }),
        );
      }
    },
  });
